import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import styledComponents from '../styles/MapContainer-style'
import "../styles/MapContainer.css";
import SelectCity from './SelectCity'
// import areaDataUrl from '../data/coastZone48.geojson'
import MapGL, { Source, Layer, NavigationControl, LinearInterpolator } from "react-map-gl";
import axios from 'axios'
import { useQuery } from 'react-query'
// import Select from 'react-select';
import {
    countiesLayer, countiesFillLayer, highlightLayer, highlightLayer2, yearFillLayer, yearLineLayer,
    yearFillLayerSeaweed, yearLineLayerSeaweed,
    yearFillLayerSalt, yearLineLayerSalt,
    clusterLayer, clusterCountLayer, unclusteredPointLayer,
    clusterLayerSeaweed, clusterCountLayerSeaweed, unclusteredPointLayerSeaweed,
    clusterLayerSalt, clusterCountLayerSalt, unclusteredPointLayerSalt,
    // unclusteredPointHighlightLayer
} from './layers/layer';

const fetchYearData = async (year, menu) => {
    let menuKey = '';
    switch (menu) {
        case 0: menuKey = 'tf'; break;
        case 1: menuKey = 'sg'; break;
        case 2: menuKey = 'sm'; break;
    }
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/${menuKey}/${year}`)
    return data
}
const MAPBOX_TOKEN = "pk.eyJ1IjoiaHl1bm1pbiIsImEiOiJja3JrZzh2N2QyMGp5MzFvMmlhOHZyZWJqIn0.BZro_OCBGxLy7n7Sbxz95w";
const { CustomMapWrapper, CustomMap, SelectAreaAbsoluteContainer, LayerControl, LayerPanel, LayerPanelItem, Checkbox, LayerItem } = styledComponents;

const MapContainer = (props) => {
    const { YearUrl, areaSelect, handleSelectedAreaName, SelectedTabId, dataInvestigation, areaDataUrl, handleSelectedAreaInfo, SelectedAreaInfo, SelectedPrevYear, MenuId, handleTable, SelectedPrevYearAreaChange, handleImageList } = props;
    const [, setdata] = useState({})
    const [isDropdownOpen, setisDropdownOpen] = useState(false)
    const [isLayerPanelOpen, setisLayerPanelOpen] = useState(false)
    const { data, isLoading } = useQuery(['yearId', YearUrl, MenuId], () => fetchYearData(YearUrl, MenuId));

    const [DropdownDefault, setDropdownDefault] = useState({ SD: SelectedAreaInfo.SD, SG: SelectedAreaInfo.SG, coordinates: [127.100616, 37.402142] })
    const [LayerVisible01, setLayerVisible01] = useState(false)
    const [LayerVisible02, setLayerVisible02] = useState(false)
    const [LayerVisible03, setLayerVisible03] = useState(false)
    const [LayerVisible04, setLayerVisible04] = useState(false)

    const mapRef = useRef(null);

    const [viewport, setViewport] = useState({
        latitude: 36.402142,
        longitude: 127.100616,
        zoom: 5,
    });
    const [hoverInfo, setHoverInfo] = useState(null);
    const [selectInfo, setSelectInfo] = useState({ value: '대한민국' });

    const navControlStyle = {
        right: 20,
        top: 20
    };

    const getYearData = async (year, menu) => {
        // let menuKey = (menu === 0 ? 'tf' : 'sm');
        let menuKey = '';
        switch (menu) {
            case 0: menuKey = 'tf'; break;
            case 1: menuKey = 'sg'; break;
            case 2: menuKey = 'sm'; break;
        }
        const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/${menuKey}/${year}`)
        return data;
    }

    useEffect(() => {
        getYearData(YearUrl, MenuId).then((res) => {
            setdata(res)
        })
    }, [YearUrl, MenuId, SelectedPrevYear, SelectedPrevYearAreaChange])

    // sea_areas 레이어
    const seaAreasLayer = {
        id: 'seaArea',
        type: 'line',
        source: 'seaAreas',
        filter: ['has', 'area'],
        paint: {
            "line-color": "#6000AB",
            "line-width": 1,
            "line-opacity": 0.3
        },
        layout: {
            'visibility': LayerVisible01 ? 'visible' : 'none'
        }
    };

    // sea_areas 레이어
    // const seaAreasLayer2 = {
    //     id: 'seaArea',
    //     type: 'line',
    //     source: 'seaAreas',
    //     filter: ['get', 'area'],
    //     paint: {
    //         "line-color": "#6000AB",
    //         "line-width": 1,
    //         "line-opacity": 0.3
    //     },
    //     layout: {
    //         'visibility': LayerVisible01 ? 'visible' : 'none',
    //     }
    // };

    // 해양보호구역 레이어
    const marineProtectedAreasLayer = {
        id: 'marineProtectedArea',
        type: 'fill',
        source: 'marineProtectedAreas',
        paint: {
            "fill-color": "#004FAB",
            "fill-opacity": 0.3
        },
        layout: {
            'visibility': LayerVisible03 ? 'visible' : 'none'
        }
    };

    // wetland_areas 습지보호구역 레이어
    const wetlandAreasLayer = {
        id: 'wetlandArea',
        type: 'fill',
        source: 'wetlandAreas',
        paint: {
            "fill-color": "#00AB3A",
            "fill-opacity": 0.2
        },
        layout: {
            'visibility': LayerVisible02 ? 'visible' : 'none'
        }
    };

    // 갯벌 그리드 레이어
    const tfGridLayer = {
        id: 'tfGrid',
        type: 'line',
        source: 'tf_grid',
        paint: {
            "line-color": "#6D6D6D",
            "line-width": 1,
            "line-opacity": 1
        },
        layout: {
            'visibility': LayerVisible04 ? 'visible' : 'none'
        }
    };

    const generateGeojson = useCallback(() => {
        if (dataInvestigation) {
            let values;
            let investigationList = [
                {
                    'type': 'FeatureCollection',
                    'features': []
                }];
            if (MenuId === 0) {
                values = dataInvestigation.filter(item => (item.se_code) === 1);
            } else if (MenuId === 1) {
                values = dataInvestigation.filter(item => (item.se_code) === 3);
            } else if (MenuId === 2) {
                values = dataInvestigation.filter(item => (item.se_code) === 2);
            } else {
                values = dataInvestigation.filter(item => (item.se_code) === 1);
            }
            // console.log('===========================dataInvestigation')
            // console.log(values)
            // console.log(SelectedAreaInfo)
            if (SelectedAreaInfo) { 
                // console.log('줌 초기화') 
                setViewport({
                    ...viewport,
                    latitude: 36.402142,
                    longitude: 127.100616,
                    zoom: 5,
                    transitionInterpolator: new LinearInterpolator({
                        around: [127.100616, 36.402142]
                    }),
                    transitionDuration: 1000,
                });
            }

            values.map((item) => {
                const geojson =
                {
                    type: "Feature",
                    properties: {
                        id: item.vtx_id,
                        code: item.se_code,
                    },
                    geometry: {
                        type: "Point",
                        coordinates: [item.lo, item.la],
                    }
                };
                investigationList[0].features.push(geojson)
                return investigationList;
            })
            return investigationList;
        }
    }, [dataInvestigation, MenuId])
    const investigationAll = useMemo(() => generateGeojson(), [MenuId]);

    // 마우스 호버시 선택된 지역 폴리곤 레이어 하이라이트
    // const onHover = useCallback(event => {
    //     const county = event.features && event.features[0];
    //     if (county.properties.area) {
    //         setSeaAreaInfo(county.properties.area)
    //         console.log(county.properties.area, 'county hover');
    //     }
    // }, []);

    // 클릭으로 지역 선택시, 선택된 지역 정보 전달
    const getAreaSelected = (item) => {
        if (item === '대한민국') {
            let coordinates = [127.100616, 36.402142]
            setViewport({
                ...viewport,
                longitude: coordinates[0],
                latitude: coordinates[1],
                zoom: 6,
                transitionDuration: 1000,
                countyName: item
            });
            setSelectInfo({
                longitude: coordinates[0],
                latitude: coordinates[1],
                value: item
            });

            setHoverInfo({
                longitude: coordinates[0],
                latitude: coordinates[1],
                countyName: item
            })
            handleSelectedAreaInfo({ SD: '대한민국', SG: null })

            handleSelectedAreaName(item)

            setDropdownDefault({ SD: '대한민국', SG: '대한민국', coordinates })
            setisDropdownOpen(false)
            return;
        }
        let coordinates = item.split(',');
        coordinates[0] = parseFloat(coordinates[0]);
        coordinates[1] = parseFloat(coordinates[1])
        onAreaSelect(coordinates)
        // onHover()
        let SD_NM = coordinates[coordinates.length - 1];
        let SG_NM = coordinates[coordinates.length - 2];
        handleSelectedAreaName(SG_NM);

        setDropdownDefault({ SD: SD_NM, SG: SG_NM, coordinates: coordinates[0] + coordinates[1] })
        setisDropdownOpen(false)
    }

    const handleDropdown = () => {
        setisDropdownOpen(!isDropdownOpen)
    }

    // 드롭다운에서 선택된 지역으로 뷰포트 줌인 이동
    const onAreaSelect = useCallback(event => {
        setSelectInfo({
            longitude: event[0],
            latitude: event[1],
            value: event[2]
        });

        setHoverInfo({
            longitude: event[0],
            latitude: event[1],
            countyName: event[2]
        })

        setViewport({
            ...viewport,
            longitude: event[0],
            latitude: event[1],
            zoom: 9,
            // transitionInterpolator: new LinearInterpolator({
            //     around: [event[0], event[1]]
            // }),
            transitionDuration: 1000,
            countyName: event[2]
        });
        handleSelectedAreaInfo({ SD: event[3], SG: event[2] })
    }, [handleSelectedAreaInfo, viewport]);

    // 클릭으로 지역 선택시 뷰포트 줌인
    const onAreaClick = useCallback(event => {
        const county = event.features && event.features[0];
        setSelectInfo({
            longitude: event.lngLat[0],
            latitude: event.lngLat[1],
            value: county && county.properties.SG
        });

        setHoverInfo({
            longitude: event.lngLat[0],
            latitude: event.lngLat[1],
            countyName: county && county.properties.SG
        })
        if (county) {
            setViewport({
                ...viewport,
                longitude: event.lngLat[0],
                latitude: event.lngLat[1],
                zoom: 9,
                transitionInterpolator: new LinearInterpolator({
                    around: [event.offsetCenter.x, event.offsetCenter.y]
                }),
                transitionDuration: 1000,
                countyName: county && county.properties.SG
            });
            handleSelectedAreaName(county.properties.SG)
            handleSelectedAreaInfo({ SD: county.properties.SD, SG: county.properties.SG })
            setDropdownDefault({ SD: county.properties.SD, SG: county.properties.SG, coordinates: event.lngLat })
        }
    }, [handleSelectedAreaInfo, handleSelectedAreaName, viewport]);

    const selectedCounty = (hoverInfo && hoverInfo.countyName) || '';
    const filter = useMemo(() => ['in', 'SG', selectedCounty], [selectedCounty]);
    const selectedArea = (selectInfo && selectInfo.value) || '';
    const filterArea = useMemo(() => ['in', 'SG', selectedArea], [selectedArea]);

    const handleLayerPanelToggle = () => {
        setisLayerPanelOpen(!isLayerPanelOpen)
    }

    const handleLayerToggle = (index) => {
        switch (index) {
            case 0: setLayerVisible01(!LayerVisible01)
                break;
            case 1: setLayerVisible02(!LayerVisible02)
                break;
            case 2: setLayerVisible03(!LayerVisible03)
                break;
            case 3: setLayerVisible04(!LayerVisible04)
                break;
            default: break;
        }
    }

    // function getCursor(event) {
    //     const feature = event.features && event.features[0];
    //     const clusterId = feature?.properties.id;
    //     if (clusterId) {
    //         return 'pointer';
    //     } else {
    //         return 'default';
    //     }
    // }

    // 현장조사 - 클릭으로 지역 선택시 뷰포트 줌인
    const onInvestigationClick = useCallback(event => {
        const county = event.features && event.features[0];
        const clusterId = county?.properties.id;

        // 현장조사 - 클릭으로 줌아웃
        // if (viewport.zoom > 10) {
        //     setViewport({
        //         ...viewport,
        //         zoom: 6
        //     })
        // } else {
        setViewport({
            ...viewport,
            longitude: event.lngLat[0],
            latitude: event.lngLat[1],
            zoom: 11,
            transitionInterpolator: new LinearInterpolator({
                around: [event.offsetCenter.x, event.offsetCenter.y]
            }),
            transitionDuration: 1000,
        });
        if (clusterId) {
            // console.log(county, clusterId, 'clusterId')
            const long = county.geometry.coordinates[0].toFixed(6);
            const lang = county.geometry.coordinates[1].toFixed(6);
            setViewport({
                ...viewport,
                longitude: event.lngLat[0],
                latitude: event.lngLat[1],
                zoom: 15,
                transitionInterpolator: new LinearInterpolator({
                    around: [event.offsetCenter.x, event.offsetCenter.y]
                }),
                transitionDuration: 1000,
                countyName: county && county.properties.SG
            });

            const  result  = axios.get(`${process.env.REACT_APP_API_HOST}/bc/investigation/${clusterId}`);
            console.log(`${process.env.REACT_APP_API_HOST}/bc/investigation/${clusterId}`)
            result.then((res) => {
                if (res.status === 200) {
                    const table = res.data;
                    handleTable(table)

                    // https://bc-old.kesti.info/bc/get_img_url?vtx_id=DY-SL
                    const imageUrl = axios.get(`${process.env.REACT_APP_API_HOST}/bc/get_img_url?vtx_id=${clusterId}`)
                    imageUrl.then((res) => {
                        if (res.status === 200) {
                            const image = res.data.urls;
                            let imageList = [];
                            if (image[0] !== undefined) {
                                image.map((item) => {
                                    // console.log(item)
                                    let imageItem = `${process.env.REACT_APP_API_HOST}/${item}`
                                    imageList.push(imageItem)
                                    handleImageList(imageList)
                                    return imageList;
                                })
                            } else {
                                imageList = [];
                                handleImageList(imageList)
                            }
                            // console.log(imageList, 'imageList')
                        }
                    })
                }
            })
        }
    }, [handleTable, viewport]);

    if (isLoading) {
        return <CustomMapWrapper>Loading...</CustomMapWrapper>
    }
    // if (isError) {
    //     return <div>Error! {error.message}</div>
    // }

    return (
        <>
            <CustomMap>
                {SelectedTabId !== 2 &&
                    <SelectAreaAbsoluteContainer>
                        <SelectCity areaSelect={areaSelect} getAreaSelected={getAreaSelected} DropdownDefault={DropdownDefault}
                            isDropdownOpen={isDropdownOpen} handleDropdown={handleDropdown} />
                    </SelectAreaAbsoluteContainer>
                }
                <LayerControl
                    onClick={handleLayerPanelToggle}>{isLayerPanelOpen ?
                        <img alt="layer" src="./images/layersIcon.svg" style={{ paddingTop: "1px" }} />
                        :
                        <img alt="layer" src="./images/layersOffIcon.svg" />
                    }</LayerControl>
                {isLayerPanelOpen &&
                    <>
                        <LayerPanel>
                            <LayerPanelItem onClick={() => handleLayerToggle(0)}>
                                <Checkbox color={'#6000AB'}>
                                    <span>{LayerVisible01 ? 'v' : ''}</span>
                                </Checkbox>
                                <LayerItem color={'#6000AB'}>해양생태구</LayerItem>
                            </LayerPanelItem>
                            <LayerPanelItem onClick={() => handleLayerToggle(2)}>
                                <Checkbox color={'#004FAB'}>
                                    <span>{LayerVisible03 ? 'v' : ''}</span>
                                </Checkbox>
                                <LayerItem color={'#004FAB'}>해양보호구역</LayerItem>
                            </LayerPanelItem>
                            <LayerPanelItem onClick={() => handleLayerToggle(1)}>
                                <Checkbox color={'#00AB3A'}>
                                    <span>{LayerVisible02 ? 'v' : ''}</span>
                                </Checkbox>
                                <LayerItem color={'#00AB3A'}>습지보호지역</LayerItem>
                            </LayerPanelItem>
                            <LayerPanelItem onClick={() => handleLayerToggle(3)}>
                                <Checkbox color={'#6D6D6D'}>
                                    <span>{LayerVisible04 ? 'v' : ''}</span>
                                </Checkbox>
                                <LayerItem color={'#6D6D6D'}>갯벌 격자 그리드</LayerItem>
                            </LayerPanelItem>
                        </LayerPanel>
                    </>
                }

                <MapGL
                    {...viewport}
                    width="100%"
                    height="100%"
                    mapStyle="mapbox://styles/hyunmin/ckuf8nkw0beut18npgk973oa5"
                    mapboxApiAccessToken={MAPBOX_TOKEN}
                    onViewportChange={setViewport}
                    // onHover={onHover}
                    // getCursor={(e) => "pointer"}
                    onClick={SelectedTabId === 2 ? onInvestigationClick : onAreaClick}
                    attributionControl={false}
                    ref={mapRef}
                >

                    <NavigationControl
                        showCompass={false}
                        style={navControlStyle} />


                    {/* 해양보호구역 레이어 3개 */}
                    <Source
                        id="marineProtectedAreas"
                        type="geojson"
                        data="https://api.bluecarbon.kr/bc/svc/41"
                    >
                        <Layer {...marineProtectedAreasLayer} />
                    </Source>

                    <Source
                        id="seaAreas"
                        type="geojson"
                        data="https://api.bluecarbon.kr/bc/svc/42"
                    >
                        <Layer {...seaAreasLayer} />
                        {/* <Layer {...seaAreasLayer2} /> */}
                    </Source>

                    <Source
                        id="wetlandAreas"
                        type="geojson"
                        data="https://api.bluecarbon.kr/bc/svc/43"
                    >
                        <Layer {...wetlandAreasLayer} />
                    </Source>

                    <Source
                        id="tf_grid"
                        type="geojson"
                        data="https://api.bluecarbon.kr/bc/svc/44"
                    >
                        <Layer {...tfGridLayer} />
                    </Source>

                    {/* coastzone 48개 지역 레이어 */}
                    {SelectedTabId !== 2 && SelectedAreaInfo.SG &&
                        <Source
                            id="areajson1"
                            type="geojson"
                            data={areaDataUrl}
                        >
                            < Layer beforeId="waterway-label" {...highlightLayer} filter={filter} />
                            {/* <Layer beforeId="waterway-label" {...highlightLayer2} filter={filterArea} /> */}
                            {/* <Layer beforeId="waterway-label" {...highlightLayer2Line} filter={filterArea} /> */}
                            <Layer {...countiesLayer} filter={filter} />
                        </Source>
                    }

                    {SelectedTabId !== 2 && !SelectedAreaInfo.SG &&
                        <Source
                            id="areajson2"
                            type="geojson"
                            data={areaDataUrl}
                        >
                            <Layer beforeId="waterway-label" {...highlightLayer2} filter={filterArea} />
                            <Layer {...countiesLayer} />
                            <Layer {...countiesFillLayer} />
                        </Source>
                    }


                    {/* 연도별 분포와 변화량 탭 레이어 */}
                    {SelectedTabId === 0 && MenuId === 0 &&
                        <>
                            <Source
                                id="mudYears"
                                type="geojson"
                                data={data}
                            >
                                <Layer  {...yearFillLayer} />
                                <Layer  {...yearLineLayer} />
                            </Source>
                        </>
                    }



                    {/* 연도별 분포와 변화량 탭 레이어 */}
                    {SelectedTabId === 0 && MenuId === 1 &&
                        <>
                            <Source
                                id="seaweedYears"
                                type="geojson"
                                data={data}
                            >
                                <Layer {...yearFillLayerSeaweed} />
                                <Layer {...yearLineLayerSeaweed} />
                            </Source>

                        </>
                    }

                    {/* 연도별 분포와 변화량 탭 레이어 */}
                    {SelectedTabId === 0 && MenuId === 2 &&
                        <>
                            <Source
                                id="seaweedYears"
                                type="geojson"
                                data={data}
                            >
                                <Layer {...yearFillLayerSalt} />
                                <Layer {...yearLineLayerSalt} />
                            </Source>

                        </>
                    }

                    {/* {SelectedTabId === 2 && menu !== 1 &&
                        <>
                            <Source
                                id="mudYears2"
                                type="geojson"
                                data={data}
                            >
                                <Layer  {...yearFillLayer} />
                            </Source>
                        </>
                    }

                    {SelectedTabId === 2 && menu === 1 &&
                        <>
                            <Source
                                id="seaweedYears2"
                                type="geojson"
                                data={data}
                            >
                                <Layer {...yearFillLayerSeaweed} />
                                <Layer {...yearLineLayerSeaweed} />
                            </Source>

                        </>
                    } */}

                    {/* 현장조사 정점 레이어 */}
                    {SelectedTabId === 2 && MenuId === 0 &&
                        <>
                            <Source
                                id="investigation"
                                type="geojson"
                                data={investigationAll && investigationAll[0]}
                                cluster={true}
                                clusterMaxZoom={10}
                                clusterRadius={50}
                            >
                                <Layer {...clusterLayer} />
                                <Layer {...clusterCountLayer} />
                                <Layer {...unclusteredPointLayer} />
                                {/* <Layer {...unclusteredPointHighlightLayer} /> */}
                            </Source>

                            {/* coastzone 48개 지역 레이어 */}
                            {/* <Source
                                id="areajson2"
                                type="geojson"
                                data={areaDataUrl}
                            >
                                <Layer {...countiesLayerInvestigation} />
                                <Layer beforeId="waterway-label" {...highlightLayerInvestigation} filter={filter} />
                                <Layer beforeId="waterway-label" {...highlightLayer2Investigation} filter={filterArea} />
                            </Source> */}
                        </>
                    }

                    {SelectedTabId === 2 && MenuId === 1 &&
                        <>
                            <Source
                                id="investigationSeaweed"
                                type="geojson"
                                data={investigationAll && investigationAll[0]}
                                cluster={true}
                                clusterMaxZoom={8}
                                clusterRadius={50}
                            >
                                <Layer {...clusterLayerSeaweed} />
                                <Layer {...clusterCountLayerSeaweed} />
                                <Layer {...unclusteredPointLayerSeaweed} />
                            </Source>
                        </>
                    }

                    {SelectedTabId === 2 && MenuId === 2 &&
                        <>
                            <Source
                                id="investigationSalt"
                                type="geojson"
                                data={investigationAll && investigationAll[0]}
                                cluster={true}
                                clusterMaxZoom={8}
                                clusterRadius={50}
                            >
                                <Layer {...clusterLayerSalt} />
                                <Layer {...clusterCountLayerSalt} />
                                <Layer {...unclusteredPointLayerSalt} />
                            </Source>
                        </>
                    }
                    {/* {seaAreaInfo && (
                        <Popup
                            longitude={seaAreaInfo.CENTROID_Y}
                            latitude={seaAreaInfo.CENTROID_X}
                            closeButton={false}
                            className="county-info"
                        >
                            {seaAreaInfo.area}
                        </Popup>
                    )} */}
                    {/* <Map ref={mapContainer} className="map-container">
                    </Map> */}
                </MapGL>
            </CustomMap>

        </>
    )
};

export default MapContainer;
